/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Save_AsInputs */

const en_views_save_as = /** @type {(inputs: Views_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as new view`)
};

const de_views_save_as = /** @type {(inputs: Views_Save_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als neue Ansicht speichern`)
};

/**
* | output |
* | --- |
* | "Save as new view" |
*
* @param {Views_Save_AsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_save_as = /** @type {((inputs?: Views_Save_AsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Save_AsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_save_as(inputs)
	return en_views_save_as(inputs)
});